import { saveFilterState } from './filterState';
import { loadCollection } from './filtering';
import closeFilterSortSubnav from './closeFilterSortSubnav';
import SuggestionsSearch from '../../components/overlay-search-nosto/suggestions-search';
import recommendationListVisibility from './recommendationListVisibility';

export default (from_search) => {
  const prefix = (from_search) ? 'overlay-search-' : '';
  window.isSorting = false; // Radio can trigger 2 times due to focus
  
  const setFocusToNextSortingItem = ($item) => { 
    const element_index = $item.parent().index();
    const total_items_in_element = $item.closest('ul').find('li').length;
  
    // console.log('sorting next total_items_in_element', total_items_in_element);
    // console.log('sorting next element_index', element_index);
    if (element_index + 1 < total_items_in_element) {
      $item.closest(`[data-${prefix}sort-by]`).find('li').eq(element_index + 1).find('.custom-radio').trigger('focus');
    } else {
      closeFilterSortSubnav();
    }
  };
  
  const setFocusToPreviousSortingItem = ($item) => {
    const element_index = $item.parent().index();
    // const total_items_in_element = $item.closest('ul').find('li').length;
  
    // console.log('sorting prev total_items_in_element', total_items_in_element);
    // console.log('sorting prev element_index', element_index);
  
    if (element_index - 1 >= 0) {
      $item.closest(`[data-${prefix}sort-by]]`).find('li').eq(element_index - 1).find('.custom-radio').trigger('focus');
    } else {
      closeFilterSortSubnav();
    }
  };

  const setFocusToFirstSortingItem = ($item) => { 
    $item.find('li').first().find('input').trigger('focus');
  };

  const selectSortingSubnav = ($subnav) => {
    closeFilterSortSubnav($subnav.closest('.filters-panel-v2__buttons').find('.filter-button-desktop'));

    $subnav.parent().toggleClass('active');
    const is_active = $subnav.parent().hasClass('active');

    if (is_active) {
      $subnav.attr('aria-expanded', true);
      const $sort_by = $subnav.parent().find(`[data-${prefix}sort-by]`);
      $sort_by.attr('tabindex', '1');

      setFocusToFirstSortingItem($sort_by);
    } else {
      closeFilterSortSubnav($subnav);
    }
  };
  
  $(document).on('keydown', `[data-${prefix}sort-by] .custom-radio`, (e) => {
    const $item = $(e.currentTarget);
    const key = e.which;
    // console.log('key', key, $(':focus'));
  
    switch (key) {
      // Enter / spacebar
      case 13:
      case 32:
        $item.find('input').trigger('click');
        break;

      // left
      case 37:
        setFocusToPreviousSortingItem($item);
        break;
  
      // right
      case 39:
        setFocusToNextSortingItem($item);
        break;
    
      // down
      case 40:
        setFocusToFirstSortingItem($item);
        break;
    }
  });

  // Click the desktop "sort by" button
  $(document).on('click', `[data-${prefix}show-desktop-sort-nav]`, (e) => {
    const $item = $(e.currentTarget);
    selectSortingSubnav($item);
  });

  $(document).on('keydown', `[data-${prefix}show-desktop-sort-nav]`, (e) => {
    const key = e.which;
  
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  // Select a new sorting option (desktop / mobile)
  $(document).on('change', `[data-sort-by]`, async (e) => {
    try {
      if (window.isSorting) {
        return;
      }
      window.isSorting = true;

      const target = e.currentTarget;
      const from_search = document.body.classList.contains('has-overlay-search');

      const mobile_parent = e.currentTarget.closest('[data-mobile-filter-sorting]');
      const is_mobile = (mobile_parent !== null);
      console.log('is_mobile', is_mobile);

      // Get selected sorting value
      const checked_input = target.querySelector(`input[name="sortby${(is_mobile) ? '-mobile' : ''}"]:checked`);
      if (!checked_input) {
        console.log('No sorting option selected');
        return;
      }

      window.theme.collections.sorting = checked_input.value;

      // Activate the same option on desktop/mobile (doesn't trigger the click event!)
      if (is_mobile) {
        const desktop_input = document.querySelector(`[data-show-desktop-sort-nav]`)?.parentElement?.querySelector(`[data-sort-by] input[name="sortby"][value="${window.theme.collections.sorting}"]`);
        if (desktop_input) {
          desktop_input.checked = true;
        }
      } else {
        const mobile_input = document.querySelector(`[data-mobile-filter-sorting] input[name="sortby-mobile"][value="${window.theme.collections.sorting}"]`);
        if (mobile_input) {
          mobile_input.checked = true;
        }

        // document.querySelectorAll('[data-mobile-filter-child="sort-by"] .mobile-filter__option').forEach(option => option.classList.remove('active'));
        // document.querySelector(`[data-mobile-filter-child="sort-by"] [data-option-value="${window.theme.collections.sorting}"]`)?.classList.add('active');
      }

      recommendationListVisibility();
      closeFilterSortSubnav($(target));
      saveFilterState();
      await loadCollection();
      window.isSorting = false;
    } catch (error) {
      console.error('Error during sort change:', error);
    } finally {
      window.isSorting = false;
    }
  });
  
  $(document).on('change', '[data-overlay-search-sort-by]', async (e) => {
    if (window.isSorting) {
      return;
    }
    window.isSorting = true;

    const item = e.currentTarget;

    const is_mobile = item.classList.contains('mobile-overlay-search-filter-sorting__items');

    // Get sorting value
    window.theme.search.sorting = document.querySelector(
      is_mobile 
        ? '[data-overlay-search-sort-by].mobile-overlay-search-filter-sorting__items input[name="sortby-mobile"]:checked'
        : '[data-overlay-search-sort-by] input[name="sortby"]:checked'
    )?.value;
    
    // Sync mobile/desktop selections
    const mobile_input = document.querySelector(`[data-overlay-search-sort-by].mobile-overlay-search-filter-sorting__items input[name="sortby-mobile"][value="${window.theme.search.sorting}"]`);
    if (mobile_input) {
      mobile_input.checked = true;
    }

    const desktop_input = document.querySelector(`[data-overlay-search-sort-by] input[name="sortby"][value="${window.theme.search.sorting}"]`);
    if (desktop_input) {
      desktop_input.checked = true;
    }

    const suggestionsSearch = new SuggestionsSearch();
    await suggestionsSearch.nostoSearch(true);

    window.isSorting = false;
  });
};
